import { createSelector } from 'reselect'
import getRenderCountAppSelect from 'modules/app/selectors/get-render-count/index.js'

const isFirstRenderAppSelect = createSelector(
  getRenderCountAppSelect,
  renderCount => {
    return !renderCount
  }
)

export default isFirstRenderAppSelect
